import React from 'react';
import { Link } from "gatsby"
import Photo01 from '../assets/Design.png';
import Photo02 from '../assets/Coaching.jpg';

const HeaderCaseDeSucesso = () => {
    return (
      <div className='
      '>
			<p class="text-center py-5 px-5 uppercase tracking-wide font-size-ronsof-p5 text-sm text-white font-bold">Depoimentos de cases de sucesso</p>
      <div class="animasion1 formStyle1 gallery autoplay items-5">
				<div id="item-1" class="control-operator"></div>
				<div id="item-2" class="control-operator"></div>
				<div id="item-3" class="control-operator"></div>
        <div id="item-4" class="control-operator"></div>
        <div id="item-5" class="control-operator"></div>
			
				<figure class="item">
					<div>
            <p>
              “Depois de passar um período fora do país, 
              percebi ao retornar que não queria mais certos 
              incômodos só para agradar outras pessoas e, por isso,
              precisava me posicionar de maneira mais assertiva
              diante de algumas situações. Então, quando retornei, 
              procurei pela Carla e iniciamos o processo de coaching.
              A cada sessão, ela super engajada e atenciosa foi trazendo 
              o foco novamente para mim, me mostrando que minhas opiniões 
              e vontades deveriam ser expressadas e me orientava com 
              “ferramentas” para eu usar em situações difíceis. No começo,
              colocar em prática o que conversávamos não era fácil, mas ela
              sempre dizia: é uma questão de praticar, e isso me servia 
              como um “cutucão” e me incentivava, pois se estava ali tinha que
              fazer, senão nada mudaria. Hoje finalizei as 10 sessões e me 
              sinto mais leve, extremamente feliz comigo e muito satisfeita
              com o trabalho da Carla, pois em tão pouco tempo consigo me 
              impor de maneira firme, positiva e calma. Tornou-se um 
              comportamento automático e assim me sinto mais forte e 
              confiante. Já disse isso a ela, em uma das sessões ela me 
              perguntou qual o sentimento que eu teria se eu atingisse o meu
              objetivo, e eu respondi que seria GRATIDÃO, e é esse o 
              sentimento que eu tenho por ela, porque com todos os 
              “cutucões e ferramentas” que ela me deu, eu consegui!⠀
              Muito obrigada Carla, por todo empenho e carinho comigo. 
              Logo estarei de volta para o meu próximo passo. Sucesso!!!“
            </p>
            <p>Cristiane dos Santos</p>
            <p>Farmacêutica</p>
          </div>
				</figure>
        <figure class="item">
					<div>
            <p>
              “ Depois da minha licença maternidade ‘estendida’ de dez meses, 
              voltei para empresa com a proposta de trabalhar meio período, para 
              que eu pudesse curtir um pouco mais meu bebê. Começaram as cobranças, 
              de um lado meu pai, que é diretor da empresa, dizendo que trabalhando 
              somente meio período eu não conseguiria ocupar o lugar dele, já que o 
              mesmo se ausentaria para novos negócios, por outro lado eu me cobrava 
              por achar que não estava exercendo da melhor forma minha função e não 
              estar em tempo integral com meu bebê.⠀Me sentia confusa e insegura com 
              tantas novidades, foi quando procurei a Carla, com a ajuda dela consegui 
              me organizar melhor com os horários, me posicionar como líder, aprendi 
              delegar e cobrar os colaboradores sem me sentir mal, comecei a cuidar da 
              minha aparência, foi incrível tantas mudanças em tão pouco tempo.⠀O meu 
              melhor feedback foi saber que meu pai falou pra minha mãe que eu estou 
              resolvendo muito mais coisa em meio período do que eu fazia em período 
              integral nos últimos 12 anos.⠀Hoje me sinto realizada, consigo traçar 
              metar e alcançá-las, e o melhor, tudo acontece naturalmente, porque 
              tornou-se um hábito tudo que aprendi com a Carla.⠀Como já te disse 
              Carla, você é uma excelente profissional, obrigada!“
            </p>
            <p>Tatiane Cristina Bombonato Santos</p>
            <p>Empresária-Ramo Moveleiro</p>
          </div>
				</figure>
        <figure class="item">
					<div>
            <p>
              “ O coaching foi para mim uma experiência incrível, que eu vou levar 
              comigo, com muito carinho, pelo resto da minha vida. É até difícil colocar 
              em palavras tudo o que o coaching me proporcionou, desde um equilíbrio 
              emocional mais sólido até um relacionamento melhor com os meus amigos e 
              familiares. Além disso, durante as sessões consegui descobrir mais sobre mim
               do que eu mesma sabia, aprendi a lidar com meus defeitos e fraquezas e a 
               aperfeiçoar as minhas qualidades. O coaching me ensinou que todo sonho é 
               possível de ser alcançado com dedicação, organização e principalmente 
               equilíbrio. E por fim, ele me deu não apenas um coach, mas uma amiga muito 
               especial, que espero levar pra vida toda! “
            </p>
            <p>Gabi Yoshida</p>
            <p>Estudante</p>
          </div>
				</figure>
        <figure class="item">
					<div>
            <p>
              “Sou uma pessoa que acredita que em alguns momentos da vida existem umas pausas
              embutidas na correria do dia-a-dia… Sou das que gostam de perceber essas 
              pausas. De observar que o caminho se bifurca e devemos fazer escolhas… Sou 
              médica especializada em otorrinolaringologia, sono e estética facial, formada 
              por uma faculdade conceituada e desde que terminei minha formação, sempre senti 
              necessidade de ter um canal de comunicação, onde eu pudesse expor dicas 
              relacionadas à medicina ou não… E arrisquei! Mas para mim, todo esse universo 
              é muito novo… Foi aí que entrou a Carla em minha vida!⠀Falar da Carla sem que 
              eu deixe interferir um pouquinho a amizade que conquistamos, é difícil, pois meu 
              carinho transborda nas palavras! Mas em termos práticos, o trabalho dela foi 
              essencial para que eu pudesse realizar esse novo meu! Exemplos de como ela me 
              ajudou variam desde a organização de horários, até a desmistificação de algumas 
              daquelas crenças limitantes! Ela me ajudou a distinguir uma ilusão de um sonho! 
              E me instigou a realizá-los! Sem interferir nas decisões, ela me ensinou a usar 
              ferramentas para minhas escolhas! A encontrar respostas que já estão embasadas de 
              acordo com meus conceitos de vida e minha moral, que apenas ainda não foram 
              exteriorizadas! Em resumo, me aplicou técnicas que viraram lições que levarei 
              para a vida toda! Além da consideração, carinho e amizade! Sucesso!“
            </p>
            <p>Mari Rossi</p>
            <p>Médico e Digital influenciar</p>
          </div>
				</figure>
        <figure class="item">
					<div>
            <p>
              “Chamo o processo pelo qual passei com a Carla de um caminho de autoconhecimento. 
              Foi muito importante parar para me conhecer melhor, definir minhas prioridades, 
              traçar rotas para alcançar os meus objetivos e ela me apresentou técnicas e 
              ferramentas para isto. As coisas começam a sair do papel e tomar forma. Lembro 
              muito de uma dica que ela me deu: tente visualizar sua vida quando suas metas forem 
              atingidas!! Isso me serve de impulso todos os dias. Foi muitoooo bom!! Obrigada, 
              Carla!! Gostaria ter essas sessões de coaching para sempre.“
            </p>
            <p>Gabriela Formosa Parreira Gregório</p>
            <p>Engenheira e Professora</p>
          </div>
				</figure>
			
        <div class="py-5 justify-center controls">
					<a href="#item-1" class="control-button">•</a>
					<a href="#item-2" class="control-button">•</a>
					<a href="#item-3" class="control-button">•</a>
          <a href="#item-4" class="control-button">•</a>
          <a href="#item-5" class="control-button">•</a>
			  </div>
      </div>
      
		</div>    
    )
}
export default HeaderCaseDeSucesso